import { apiCall } from "../../axios";
import { useMutation } from "@tanstack/react-query";

export const sendVerificationEmail = (user) => {
  return new Promise((resolve, reject) => {
    return apiCall({
      method: "post",
      url: "api/email/verification-email",
      data: user,
      shouldRedirect: false,
    })
      .then(resolve)
      .catch(reject);
  });
};

export const useSendVerificationEmail = ({ onSuccess, onError }) =>
  useMutation({
    mutationFn: (user) => sendVerificationEmail(user),
    onSuccess,
    onError,
  });

export default useSendVerificationEmail;
